import { forwardRef } from 'react'
import type { ElementRef } from 'react'

import { MagnifyingGlassIcon as SearchIcon } from '@radix-ui/react-icons'
import { CSS } from '@stitches/react'

import Box from 'components/atomic/atoms/box'
import Input, { InputProps } from 'components/atomic/atoms/input'

const NAME = 'InputSearch'

const InputSearch = forwardRef<
  ElementRef<typeof Box>,
  InputProps & { containerCss?: CSS }
>(({ css, containerCss, ...props }, forwardedRef) => {
  return (
    <Box relative css={containerCss} ref={forwardedRef}>
      <Box
        absolute
        flex
        items="center"
        css={{ left: '$2', height: '$full', color: '$text4' }}
      >
        <SearchIcon width={18} height={18} />
      </Box>
      <Input
        placeholder="Search"
        {...props}
        css={{ pl: '$8', ...css }}
        type="search"
      />
    </Box>
  )
})

InputSearch.displayName = NAME

export default InputSearch
